/* Mirra Masa | Click/tap-only persistent swatch ring
   Delegated event handling covers Ajax-loaded cards and product sections.
   Shopify's own variant-selection handlers and hover previews stay unchanged. */
(function () {
  'use strict';
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var swatch = target.closest(
      '.t4s-swatch__option.is-t4s-style__color .t4s-swatch__list > .t4s-swatch__item.is-sw__color, ' +
      '.t4s-product-colors > .t4s-pr-color__item:not(.is--colors-more)'
    );
    if (!swatch) return;

    if (swatch.classList.contains('is--soldout') ||
        swatch.classList.contains('is--unavailable') ||
        swatch.classList.contains('t4s-pr-color--sold-out') ||
        swatch.getAttribute('aria-disabled') === 'true') return;

    var list = swatch.closest('.t4s-swatch__list, .t4s-product-colors');
    if (!list) return;
    var choices = list.matches('.t4s-product-colors')
      ? list.querySelectorAll(':scope > .t4s-pr-color__item:not(.is--colors-more)')
      : list.querySelectorAll(':scope > .t4s-swatch__item.is-sw__color');

    choices.forEach(function (item) {
      item.classList.remove('mm-swatch-clicked');
    });
    swatch.classList.add('mm-swatch-clicked');
  }, true);
})();
